import{
  GenerateRandomId,
  chromeExtension,
  productID
} from './const/certenrollment.js'

import { checkExtension } from './const/browser.js'
import { SendMsg } from './sendMsg/index'

export const cofco_connect = ()=> {
  return checkExtension()
  .then((res)=> {
      return SendMsg({action: "connect", host: productID})
  })
  .then((res)=> {
      return SendMsg({action: "checkHost"})
  })
}

// 连接扩展
export const connect = ()=> {
  return checkExtension()
  .then((res)=> {
      return SendMsg({action: "connect", host: productID})
  })
  .then((res)=> {
      return SendMsg({action: "checkHost"})
  })
}


export const CFCA_GetCSPInfo = () => {
  let request = {
    action: 'invoke',
    funcInfo: {
      function: 'CFCA_GetCSPInfo',
      params:[],
      randomId: GenerateRandomId()
    }
  }
  return SendMsg(request)
}

export const CFCA_SetCSPInfo = (lKeyLength, bstrCSPName) => {
  let request = {
    action: 'invoke',
    funcInfo: {
      function: 'CFCA_SetCSPInfo',
      params:[lKeyLength, bstrCSPName],
      randomId: GenerateRandomId()
    }
  }
  return SendMsg(request)
}

export const CFCA_SetKeyAlgorithm = (bstrKeyAlgorithm) => {
  let request = {
    action: 'invoke',
    funcInfo: {
      function: 'CFCA_SetKeyAlgorithm',
      params:[bstrKeyAlgorithm],
      randomId: GenerateRandomId()
    }
  }
  return SendMsg(request)
}

export const CFCA_ImportEncryptCert = (bstrEncryptedPrivateKey, bstrP7Cert, bstrContainerName, lEncryptCertPrivateKeyFlags) => {
  let request = {
    action: 'invoke',
    funcInfo: {
      function: 'CFCA_ImportEncryptCert',
      params:[bstrEncryptedPrivateKey, bstrP7Cert, bstrContainerName, lEncryptCertPrivateKeyFlags],
      randomId: GenerateRandomId()
    }
  }
  return SendMsg(request)
}

export const CFCA_GetContainer = () => {
  let request = {
    action: 'invoke',
    funcInfo: {
      function: 'CFCA_GetContainer',
      params:[],
      randomId: GenerateRandomId()
    }
  }
  return SendMsg(request)
}

export const CFCA_ImportSignCert = (lCertType, bstrSignCert, keyName) => {
  let request = {
    action: 'invoke',
    funcInfo: {
      function: 'CFCA_ImportSignCert',
      params:[lCertType, bstrSignCert, keyName],
      randomId: GenerateRandomId()
    }
  }
  return SendMsg(request)
}

export const CFCA_PKCS10CertRequisition = (bstrSubjectDN, lCertType, lSignPrivateKeyGenerateFlags) => {
  let request = {
    action: 'invoke',
    funcInfo: {
      function: 'CFCA_PKCS10CertRequisition',
      params:[bstrSubjectDN, lCertType, lSignPrivateKeyGenerateFlags],
      randomId: GenerateRandomId()
    }
  }
  return SendMsg(request)
}

export const CFCA_GetAllCertInfo = () => {
  let request = {
    action: 'invoke',
    funcInfo: {
      function: 'CFCA_GetAllCertInfo',
      params:[],
      randomId: GenerateRandomId()
    }
  }
  return SendMsg(request)
}

export const CFCA_GetVersion = () => {
  let request = {
    action: 'invoke',
    funcInfo: {
      function: 'CFCA_GetVersion',
      params:[],
      randomId: GenerateRandomId()
    }
  }
  return SendMsg(request)
}


var C_keyAlgorithm = "RSA"
var C_keyLength = 2048

// 获取取得当前密钥对的密钥容器名称
export const getContainer = () => {
  return connect().then((result) => {
    return CFCA_GetContainer()
  })
}

export const PKCS10Requisition_SingleCert = () => {
  var strSubjectDN = "CN=certRequisition,O=CFCA TEST CA,C=CN";
  return connect()
      .then((res) => { 
        return CFCA_GetCSPInfo()
      })
      .then(function (response) {
        console.log('1-----CFCA_GetCSPInfo',response)
          let result = response.result;
          let csps = result.split('||');
          let current = csps.filter(f => f.indexOf('Microsoft') == -1);
          console.log(current)
          return CFCA_SetCSPInfo(C_keyLength, current[0])
      })
      .then(function (response) { 
        console.log('2-----CFCA_SetCSPInfo',response)
        return CFCA_SetKeyAlgorithm(C_keyAlgorithm) 
      })
      .then(function (response) { 
        console.log('3-----CFCA_SetKeyAlgorithm',response)
        return CFCA_PKCS10CertRequisition(strSubjectDN, 1, 0) 
      })
      .then(function (response) {
        console.log('4-----CFCA_PKCS10CertRequisition',response)
        // return CFCA_GetContainer()
        // return Promise.resolve(response.result.replace(/[\r\n]/g, ""))
      })
}


export const InstallCert = (certType=1, signCert, keyName) => {
  return connect()
      .then((res) => { 
        return CFCA_GetCSPInfo()
      })
      .then(function (response) {
        console.log('1-----CFCA_GetCSPInfo',response)
          let result = response.result
          let csps = result.split('||')
          let current = csps.filter(f => f.indexOf('Microsoft') == -1)
          return CFCA_SetCSPInfo(C_keyLength, current[0])
      })
      .then(function (response) { 
        console.log('2-----CFCA_SetCSPInfo',response)

          return CFCA_SetKeyAlgorithm(C_keyAlgorithm)
      })
      .then(function (response) { 
        console.log('3-----CFCA_SetKeyAlgorithm',response)
          return CFCA_ImportSignCert(certType, signCert,keyName)
      })
      .then((response) => {
        console.log('4-----CFCA_ImportSignCert',response)

      })
}


// WEBPACK FOOTER //
// ./apps/cfca/cofco/api.js